import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'edge-fitness-content',
  templateUrl: './fitness-content.component.html',
  styleUrls: ['./fitness-content.component.scss']
})
export class FitnessContentComponent {
  features = [
    {
      image: 'fitness-screenshot-1.png',
      title: 'View Full 3D Exercises',
      description: `
        View full 3D exercise animations from any angle. See
        visualizations of proper breathing patterns. Use Coaching
        Mode when you're ready to get into the details.`,
      class: 'vertical-img'
    },
    {
      image: 'fitness-screenshot-2.png',
      title: 'Track Your Workouts Live',
      description: `
      Use GoArmy Edge Fitness in the gym to track your workouts.
      Easy to navigate controls allow you to update your results.
      Access the Exercise Visualizer when you need a refresher on a specific exercise.`,
      class: 'vertical-img'
    },
    {
      image: 'fitness-screenshot-3.png',
      title: 'Create Your Program',
      description: `
      Create your own Workouts and Programs, or use built-in options.
      Set up your training regimen for the next week or the next month.`,
      class: 'vertical-img'
    }
  ];

  additionalFeatures = [
    {
      title: 'Built-In Workouts',
      description: `
      Access built-in workouts to get started.
      Additional workouts will be added over time.`
    },
    {
      title: 'Create Custom Workouts',
      description: `
      Anyone can use our Workout Editor
      to create their own workouts. Start from
      scratch or modify a built-in workout.`
    },
    {
      title: 'Customize Exercises',
      description: `
      Is our Exercise Library missing a movement you need?
      Add a Custom Exercise and use it in your own workouts.`
    }
  ];
}
